export const GiftIcon = () => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="tdesign:gift">
			<path
				id="Vector"
				d="M23 22V6.00004H18.465C18.9623 5.14079 19.1223 4.1273 18.9139 3.15663C18.7055 2.18596 18.1435 1.32748 17.3373 0.748115C16.5311 0.168746 15.5383 -0.0901101 14.5518 0.0218774C13.5654 0.133865 12.6558 0.608692 12 1.35404C11.3442 0.608692 10.4346 0.133865 9.44817 0.0218774C8.46172 -0.0901101 7.46887 0.168746 6.66266 0.748115C5.85646 1.32748 5.29452 2.18596 5.0861 3.15663C4.87769 4.1273 5.03769 5.14079 5.535 6.00004H1V22H23ZM13 4.00004C13 3.4696 13.2107 2.9609 13.5858 2.58582C13.9609 2.21075 14.4696 2.00004 15 2.00004C15.5304 2.00004 16.0391 2.21075 16.4142 2.58582C16.7893 2.9609 17 3.4696 17 4.00004C17 4.53047 16.7893 5.03918 16.4142 5.41425C16.0391 5.78932 15.5304 6.00004 15 6.00004C14.4696 6.00004 13.9609 5.78932 13.5858 5.41425C13.2107 5.03918 13 4.53047 13 4.00004ZM14.414 8.00004H21V14H3V8.00004H9.586L6.586 11L8 12.414L12 8.41404L16 12.414L17.414 11L14.414 8.00004ZM3 16H21V20H3V16ZM11 4.00004C11 4.53047 10.7893 5.03918 10.4142 5.41425C10.0391 5.78932 9.53043 6.00004 9 6.00004C8.46957 6.00004 7.96086 5.78932 7.58579 5.41425C7.21071 5.03918 7 4.53047 7 4.00004C7 3.4696 7.21071 2.9609 7.58579 2.58582C7.96086 2.21075 8.46957 2.00004 9 2.00004C9.53043 2.00004 10.0391 2.21075 10.4142 2.58582C10.7893 2.9609 11 3.4696 11 4.00004Z"
				fill="black"
			/>
		</g>
	</svg>
);
